import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import { KitchenCollectionDesktop } from '@thd-olt-component-react/collection';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { VendorCollectionsRedirector } from '@thd-nucleus/app-render';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Metadata, KitchenCabinetMetadata } from '@thd-olt-component-react/metadata';
import { RecommendationsPlaceholder, RecommendationsProvider } from '@thd-olt-component-react/recommendations';
import { useParams, useHistory } from '@thd-olt-component-react/router';
import { SearchFeedback } from '@thd-olt-component-react/search-feedback';

export const KitchenCabinets = () => {
  const { collectionName } = useParams();
  const collectionItems = '';
  const resx = {
    appId: 'homedepot01',
    maxProducts: '16',
    products: collectionItems,
    card: true,
    criteo: {
      version: 'model2'
    },
    event: 'collection',
    carouselOptions: {
      fullScrollSkip: 2
    }
  };

  const history = useHistory();
  const onChange = (data = {}) => {
    history.push(data.collectionIdValue, { disableScroll: true });
  };

  return (
    <>
      <VendorCollectionsRedirector
        collectionName={collectionName}
      />
      <Metadata>
        <KitchenCabinetMetadata collectionName={collectionName} />
      </Metadata>
      <RecommendationsProvider resx={resx}>
        <Row className="isBound kitchen-cabinets">
          <ErrorBoundary name="collection">
            <KitchenCollectionDesktop
              collectionName={collectionName}
              onChange={onChange}
            />
          </ErrorBoundary>
          <Col className="grey-bg">
            <ErrorBoundary name="search-feedback">
              <SearchFeedback type="collection" />
            </ErrorBoundary>
          </Col>
          <Col className="grey-bg">
            <ErrorBoundary name="recently-viewed">
              <RecommendationsPlaceholder
                defer
                scheme="rv_gm_pip_rr"
              />
            </ErrorBoundary>
          </Col>
        </Row>
      </RecommendationsProvider>
    </>
  );
};

KitchenCabinets.dataModel = extend(
  KitchenCollectionDesktop,
  RecommendationsPlaceholder
);